export default "__VITE_ASSET__DscDcxcL__"